import { SiteItemData } from "../../../../interfaces";
import { isWcmEditor } from "config/serverConfig";
import { NewYnetTvVerticalDynamicDesktop } from "./newYnetTvVerticalDynamicDesktop";

export interface categoryObj {
    id: string
    categoryColor: string
    name: string
}

interface NewYnetTvVerticalDynamicComponentaProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    isTitleVisible: boolean
    isSubTitleVisible: boolean
    tabTitleText: string
    repeatAds: number
    maxAds: number
    firstAdPlace: number
    category: categoryObj
    domain: string
    showPrerollAds: boolean
    youtubeLink: string
    whatsappLink: string
    instagramLink: string
    twitterLink: string
    tiktokLink: string
    facebookLink: string
    tabBackgroundColor: string
    isLTR: boolean
    languageCode: string
    analyticsTitle: string
}

export class NewYnetTvVerticalDynamicComponenta extends React.Component<NewYnetTvVerticalDynamicComponentaProps, {}>{
    public static siteScriptName = "NewYnetTvVerticalDynamicComponenta";

    public render() {
        const { videoList, isTabVisible, isTitleVisible, isSubTitleVisible, tabTitleText, repeatAds, maxAds, firstAdPlace, category, domain,
            showPrerollAds, youtubeLink, whatsappLink, instagramLink, twitterLink, tiktokLink, facebookLink, tabBackgroundColor,
            isLTR, languageCode, analyticsTitle } = this.props;
        const componentClass = `${isLTR ? "newYnetTvVerticalDynamicComponentaLtr" : "newYnetTvVerticalDynamicComponenta"} ${isWcmEditor() ? "editMode" : ""}`;

        return (
            <div className={componentClass} analytics_title={analyticsTitle}>
                <NewYnetTvVerticalDynamicDesktop
                    isLTR={isLTR}
                    maxAds={maxAds}
                    domain={domain}
                    category={category}
                    videoList={videoList}
                    repeatAds={repeatAds}
                    tiktokLink={tiktokLink}
                    twitterLink={twitterLink}
                    youtubeLink={youtubeLink}
                    languageCode={languageCode}
                    isTabVisible={isTabVisible}
                    tabTitleText={tabTitleText}
                    firstAdPlace={firstAdPlace}
                    whatsappLink={whatsappLink}
                    facebookLink={facebookLink}
                    instagramLink={instagramLink}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    isSubTitleVisible={isSubTitleVisible}
                    tabBackgroundColor={tabBackgroundColor}
                />
            </div>
        )

    }
}
